import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Oct 2026 — a signed-in customer whose registration is incomplete (no
// phone yet, Google sign-up) may browse public pages but must finish
// registration before the dashboard, bookings, cart or checkout.
const GATED_PREFIXES = [
  '/dashboard', '/my-bookings', '/my-classes', '/my-races', '/my-payments', '/my-wallet',
  '/my-membership', '/family', '/profile', '/checkout', '/cart', '/buy-packages',
  '/private-booking', '/booking-confirmation', '/my-reservations', '/price-lock/offer',
];

// Admins and coaches have their own forced-change screens; students/parents
// holding an admin-set temporary password must replace it before anything else.
const PASSWORD_GATE_EXEMPT = ['/change-password', '/login', '/logout', '/forgot-password', '/reset-password', '/auth-callback', '/admin', '/coach'];

export const RegistrationGate = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const path = location.pathname;
  const next = `${path}${location.search}`;
  const exempt = PASSWORD_GATE_EXEMPT.some((p) => path === p || path.startsWith(`${p}/`));
  if (user && user.must_change_password && !['admin', 'coach'].includes(user.role) && !exempt) {
    return <Navigate to={`/change-password?returnTo=${encodeURIComponent(next)}`} replace />;
  }
  const gated = GATED_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
  if (user && user.registration_incomplete && gated) {
    return <Navigate to={`/complete-registration?returnTo=${encodeURIComponent(next)}`} replace />;
  }
  return children;
};

export default RegistrationGate;
